<template>
  <div class="overflow-hidden rounded-2xl border border-[#1c4848]/10 bg-white">
    <div class="relative flex overflow-hidden bg-[#1c4848]" :class="[HEIGHTS[attrs.height] ?? HEIGHTS.full, ALIGN[attrs.position] ?? ALIGN.bottom]">
      <img v-if="attrs.image" :src="attrs.image" alt="" class="absolute inset-0 h-full w-full object-cover" draggable="false">
      <div class="absolute inset-0" :class="SCRIM[attrs.position] ?? SCRIM.bottom"></div>
      <div class="relative w-full space-y-1 p-6">
        <div class="flex gap-2">
          <div class="w-20 shrink-0"><BlockField :model-value="attrs.number" on-dark placeholder="01" :read-only="readOnly" input-class="text-2xl font-bold text-[#ecd79f]" @update:model-value="set({ number: $event })" /></div>
          <div class="min-w-0 flex-1 self-center"><BlockField :model-value="attrs.kicker" on-dark placeholder="Small line, like Chapter" :read-only="readOnly" input-class="text-xs font-bold uppercase tracking-[0.15em] text-[#ecd79f]" @update:model-value="set({ kicker: $event })" /></div>
        </div>
        <BlockField :model-value="attrs.title" on-dark placeholder="Big title" :read-only="readOnly" input-class="font-display text-4xl font-bold leading-tight text-white" @update:model-value="set({ title: $event })" />
        <BlockField :model-value="attrs.subtitle" on-dark placeholder="One sentence under the title" :read-only="readOnly" input-class="text-base text-white/90" @update:model-value="set({ subtitle: $event })" />
      </div>
    </div>
    <div class="relative mx-6 -mt-6 rounded-2xl bg-white p-3 shadow-lg ring-1 ring-[#1c4848]/5">
      <BlockField :model-value="attrs.lead" label="Opening paragraph, on a card under the picture" placeholder="The first lines readers see. Its first letter is printed large." :read-only="readOnly" input-class="text-[15px] leading-relaxed text-[#1c4848]" @update:model-value="set({ lead: $event })" />
    </div>
    <div v-if="!readOnly" class="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 px-3 py-2">
      <ImagePicker :context="context" :has-image="Boolean(attrs.image)" compact @picked="set({ image: $event })" />
      <OptionGroup label="Look" :value="attrs.look" :options="LOOK_OPTIONS" @pick="set({ look: $event })" />
      <OptionGroup label="Height" :value="attrs.height" :options="HEIGHT_OPTIONS" @pick="set({ height: $event })" />
      <OptionGroup label="Text" :value="attrs.position" :options="POSITION_OPTIONS" @pick="set({ position: $event })" />
    </div>
  </div>
</template>

<script setup>
import BlockField from '@/components/writer/views/BlockField.vue';
import ImagePicker from '@/components/writer/views/ImagePicker.vue';
import OptionGroup from '@/components/writer/views/OptionGroup.vue';

const HEIGHTS = { full: 'min-h-[520px]', large: 'min-h-[400px]', medium: 'min-h-[280px]' };
const ALIGN = { top: 'items-start', center: 'items-center', bottom: 'items-end' };
const SCRIM = {
  top: 'bg-gradient-to-b from-black/70 via-black/20 to-transparent',
  center: 'bg-black/40',
  bottom: 'bg-gradient-to-t from-black/80 via-black/25 to-transparent',
};
const LOOK_OPTIONS = [{ value: 'glass', label: 'Glass' }, { value: 'fade', label: 'Fading' }, { value: 'arch', label: 'Arch' }];
const HEIGHT_OPTIONS = [{ value: 'full', label: 'Full screen' }, { value: 'large', label: 'Large' }, { value: 'medium', label: 'Medium' }];
const POSITION_OPTIONS = [{ value: 'top', label: 'Top' }, { value: 'center', label: 'Middle' }, { value: 'bottom', label: 'Bottom' }];

defineProps({ attrs: Object, readOnly: Boolean, context: Object, set: Function, kind: String });
</script>
